export { default } from './components/SlideBottom';
